export type StorageKeys = {
  [key: string]: string;
};

export const StorageKeys = {
  connectionStringUrl: 'sesam--persist-connection-string-url',
  changelogBase: 'sesam--changelog',
  navbar: 'sesam--navbar',
  dataTable: 'sesam--data-table-3',
  facetsKey: 'sesam--filter-facets',
  liveUpdates: 'sesam--live-updates',
  adminPowers: 'sesam--admin-powers',
  commandPalettePreferences: 'sesam--command-palette-preferences',
} as const;

export const globalLiveUpdatesSubPath = 'global-live-updates';
